import { render, staticRenderFns } from "./HiddenSubtabsButton.vue?vue&type=template&id=d49f84b0&scoped=true"
import script from "./HiddenSubtabsButton.vue?vue&type=script&lang=js"
export * from "./HiddenSubtabsButton.vue?vue&type=script&lang=js"
import style0 from "./HiddenSubtabsButton.vue?vue&type=style&index=0&id=d49f84b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d49f84b0",
  null
  
)

export default component.exports